export default "__VITE_ASSET__DdH1xi2u__"